import apiFetch from '../apiFetch'

export default function (dossierId, dossierService, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossierService?dossierId=${dossierId}`, method: 'POST', body: dossierService, token: token, lastAccessDate })
}
